<template>
  <div
    class="progress-bar"
    :class="classes">
    <div
      v-if="showPercentage"
      class="progress-bar__percentage">
      {{ percentageLabel }}
    </div>
    <div
      class="progress-bar__progress" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults( defineProps<{
  percentage: number;
  variant?: string;
  size?: "xs" | "sm" | "md" | "lg";
  showPercentage?: boolean;
}>(), {
  percentage: 100,
  variant: "primary",
  size: "sm",
  showPercentage: false,
} );

const clampedValue = computed( () => Math.max( 0, Math.min( 100, props.percentage ) ) );
const valuePercentage = computed( () => `${clampedValue.value}%` );
const percentageLabel = computed( () => `${Math.floor( clampedValue.value )}%` );

const classes = computed( () => {
  return [
    `progress-bar--${props.variant}`,
    `progress-bar--${props.size}`,
  ];
} );
</script>

<style scoped lang="scss">
.progress-bar {

  &--xs {
    --height: var(--s-2);
  }

  &--sm {
    --height: var(--s-3);
  }

  &--md {
    --height: var(--s-4);
  }

  &--lg {
    --height: var(--s-5);
  }

  --border-radius: .25rem;
  --color: var(--theme-color, --color-primary-500);
  --color-background: var(--theme-color-background, --color-primary-200);

  width: 100%;
  border-radius: var(--border-radius);

  &__progress {
    width: 100%;
    height: var(--height);
    border-radius: var(--border-radius);
    background-color: var(--color-background);

    &::after {
      content: "";
      width: v-bind(valuePercentage);
      height: var(--height);
      background-color: var(--color);
      border-radius: var(--border-radius);
      display: block;
    }
  }
}
</style>
